import { useEffect } from "react";

// import Loader from "../loader/loader";
import axios from "axios";
import Cookies from "js-cookie";
import { useState } from "react";
import regenerateToken from "../regenerateTokens";
import { Form, InputGroup, Spinner } from "react-bootstrap";
import JSONInput from "react-json-editor-ajrm";
import { Box, FormControlLabel, Stack, Switch } from "@mui/material";
import LabelElement from "../../../common/LabelElement";
import LoadingView from "../../../common/LoadingView";
import { useAlert } from "react-alert";
import handleExport from "./exportProfileContent";
import { handleImport } from "./ImportProfileContentv2";
import ProfileDisplay from "./DisplayProfileUI/ProfileDisplay";
import ProfileEditorManager from "../../../common/ProfileEditorManager";

const ProfileContent = ({  setEditVersion }) => {
  const alert = useAlert();
  const loginData = JSON.parse(localStorage.getItem("loginDetails"));
  const [profileContent, setProfileContent] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  const [reportType, setReportType] = useState("");
  const [contentType, setContentType] = useState("");
  const [language, setLanguage] = useState("");
  const [tipSection, setTipSection] = useState("");
  const [tipsLanguage, setTipsLanguage] = useState("");
  const [newLangKey, setNewLangKey] = useState("");
  const [availableLang, setAvailableLang] = useState(["en", "hi", "ar"]);
  const [availableLangObj, setAvailableLangObj] = useState({
    en: "",
    hi: "",
    ar: "",
  });
  const [availableLangArray, setAvailableLangArray] = useState({
    en: [],
    hi: [],
    ar: [],
  });
  const [selectedReportLanguage, setSelectedReportLanguage] = useState("");
  const [selectedReportLanguageCode, setSelectedReportLanguageCode] = useState("en");

  const [showLanguagePopup, setShowLanguagePopup] = useState(false);
  const [selectedReportType, setSelectedReportType] = useState("");

  const [userSelectedLanguage, setUserSelectedLanguage] = useState("en");
  const [userSelectedLanguageName, setUserSelectedLanguageName] = useState("English");
  
  const [showUI, setShowUI] = useState(false)


  const [storedVersions, setStoredVersions] = useState([]);
  const [version, setVersion] = useState("");


const fetchAllVersions = async () => {
  const idToken = localStorage.getItem("idTokenBilling");

  if (!idToken) {
    throw new Error("Authentication token is missing.");
  }

  const apiUrl = `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/version/content?versionName=all`;
  const options = {
    method: "GET",
    headers: {
      // Use the standard "Authorization" (capital A)
      Authorization: idToken,
    },
  };

  const response = await fetch(apiUrl, options);

  // Add error handling
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // Get the JSON data
  const data = await response.json();

  // Based on our previous chat, your API returns { isSuccess: true, data: [...] }
  // We just want to return the array.
  if (data.isSuccess && data.data) {
    return data.data; // This is the array of versions
  } else {
    throw new Error(data.error || "Failed to fetch versions.");
  }
};

useEffect(() => {
  const loadData = async () => {
    try {
      // 1. Call the API (it now returns the array)
      const versionArray = await fetchAllVersions();
      
      // 2. Put the array into the correct state
      setStoredVersions(versionArray);

      // 3. Keep version as "" so API is called as ?version= (live content by default)
      // Do NOT auto-select the live version by name
      
    } catch (err) {
      console.error("Failed to load data:", err);
    }
  };

  loadData();
}, []);


  const languageOptions = [
    { name: "Choose Lang", value: "" },
    { name: "czech", value: "cz" },
  ];

  const availableLanguageNames = {
    en: "English",
    hi: "Hindi",
    ar: "Arabic",
    cz: "czech",
    // Add more possible language codes
    "en-US": "English",
    "hi-IN": "Hindi",
    "ar-SA": "Arabic",
    "en-GB": "English",
    "en-IN": "English",
  };

  const reportTypeNames = {
    dynamic: "Dynamic",
    compact: "Compact",
    standard: "Standard",
    basic: "Basic",
  };

  // Support email configuration
  const SUPPORT_EMAIL = "sales@niroggyan.com";
  const SUPPORT_EMAILS = ["sales@niroggyan.com"];

  // Function to get Smart Report configuration
  const getStateConfiguration = async () => {
    const idToken = localStorage.getItem("idTokenBilling");
    const existingStateConfigBody = {
      headers: {
        authorization: idToken,
      },
      method: "GET",
      url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/config/state",
      validateStatus: function (status) {
        return status >= 200 && status <= 401;
      },
    };
    const existingStateConfigResponse = await axios(existingStateConfigBody);
    return existingStateConfigResponse;
  };

  // loader when updating the content

  const [updateLoader, setUpdateLoader] = useState(false);
  
  // Fetch Smart Report configuration to get selected report language
  useEffect(() => {
    (async function () {
      try {
        const response = await getStateConfiguration();
        
        if (response.status === 401) {
          await regenerateToken();
          const response = await getStateConfiguration();
          if (response.data.isSuccess) {
            const stateData = response.data.data.stateData;
            const curLang = stateData.curLang || stateData.language || stateData.reportLanguage || "en";
            const fullLanguageName = availableLanguageNames[curLang] || curLang || "English (Default)";
            setSelectedReportLanguage(fullLanguageName);
            setSelectedReportLanguageCode(curLang);
            
            // Set user selected language to the report language initially
            setUserSelectedLanguage(curLang);
            setUserSelectedLanguageName(fullLanguageName);
            
            const reportType = stateData.reportType || "dynamic";
            const fullReportTypeName = reportTypeNames[reportType] || reportType || "Dynamic";
            setSelectedReportType(fullReportTypeName);
          }
        } else {
          if (response.data.isSuccess) {
            const stateData = response.data.data.stateData;
            const curLang = stateData.curLang || stateData.language || stateData.reportLanguage || "en";
            const fullLanguageName = availableLanguageNames[curLang] || curLang || "English (Default)";
            setSelectedReportLanguage(fullLanguageName);
            setSelectedReportLanguageCode(curLang);
            
            // Set user selected language to the report language initially
            setUserSelectedLanguage(curLang);
            setUserSelectedLanguageName(fullLanguageName);
            
            const reportType = stateData.reportType || "dynamic";
            const fullReportTypeName = reportTypeNames[reportType] || reportType || "Dynamic";
            setSelectedReportType(fullReportTypeName);
          }
        }
      } catch (error) {
        console.log("Error fetching Smart Report config:", error.message);
        setSelectedReportLanguage("Error loading language");
        setSelectedReportType("Dynamic (Default)");
        setSelectedReportLanguageCode("en");
        setUserSelectedLanguage("en");
        setUserSelectedLanguageName("English");
      }
    })();
  }, []);

  useEffect(() => {
    (async function () {
      setPageLoader(true);
      const response = await getExistingProfileContent();
      if (response.status === 401) {
        await regenerateToken();
        const response = await getExistingProfileContent();
        if (response.data.isSuccess) {
          setProfileContent(response.data.data);
        }
      } else {
        if (response.data.isSuccess) {
          setProfileContent(response.data.data);
          setPageLoader(false);
        }
      }
      setPageLoader(false);
    })();
  }, [version]);

  // get existing languages from json
  useEffect(() => {
    const existingLanguages = detectLanguages(profileContent);
    if (existingLanguages?.length) {
      const existingLanguagesObj = existingLanguages.reduce((acc, cur) => {
        acc[cur] = "";
        return acc;
      }, {});
      const existingLanguagesArray = existingLanguages.reduce((acc, cur) => {
        acc[cur] = [];
        return acc;
      }, {});

      // update state variables
      setAvailableLang(existingLanguages);
      setAvailableLangObj(existingLanguagesObj);
      setAvailableLangArray(existingLanguagesArray);
    }
  }, [profileContent]);

  // Ensure language is set when component loads or when user selected language changes
  useEffect(() => {
    if (userSelectedLanguage && selectedProfile) {
      setLanguage(userSelectedLanguage);
      setTipsLanguage(userSelectedLanguage);
    }
  }, [userSelectedLanguage, selectedProfile]);

  const detectLanguages = (jsonData) => {
    const languageSet = new Set(); // To store unique languages

    const findLanguages = (obj) => {
      if (Array.isArray(obj)) {
        obj.forEach((item) => findLanguages(item));
      } else {
        for (let key in obj) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            findLanguages(obj[key]);
          }
          // Assuming language keys are strings like 'en', 'hi', 'ar'
          if (typeof key === "string" && key.length === 2) {
            languageSet.add(key); // Add detected language key
          }
        }
      }
    };

    findLanguages(jsonData); // Start traversing
    return Array.from(languageSet); // Return unique languages as an array
  };

  const getExistingProfileContent = async () => {
    const idToken = localStorage.getItem("idTokenBilling");
    const configBody = {
      trackActivity: true,
      headers: {
        authorization: idToken,
      },
      method: "GET",
      url: `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/content/profile?version=${version}`,
      validateStatus: function (status) {
        return status >= 200 && status <= 401;
      },
    };
    const response = await axios(configBody);
    return response;
  };

  const removeTips = (selectedTip) => {
    const requiredTips = profileContent[selectedProfile][reportType][
      contentType
    ][tipSection].tipsArray.filter(
      (eachTip) => eachTip.text.en !== selectedTip.text.en
    );
    const profileContentToBeUpdated = JSON.parse(
      JSON.stringify(profileContent)
    );
    profileContentToBeUpdated[selectedProfile][reportType][contentType][
      tipSection
    ].tipsArray = requiredTips;

    setProfileContent(profileContentToBeUpdated);
  };

  const addTips = () => {
    const defaultText = {
      en: "",
      ar: "",
      hi: "",
    };
    const emptyTip = {
      text: {
        ...availableLangObj,
      },
      svg: "",
    };
    const profileContentToBeUpdated = JSON.parse(
      JSON.stringify(profileContent)
    );
    profileContentToBeUpdated[selectedProfile][reportType][contentType][
      tipSection
    ].tipsArray.push(emptyTip);
    setProfileContent(profileContentToBeUpdated);
  };

  const updateTip = (updatedTip, type, index) => {
    const profileContentToBeUpdated = JSON.parse(
      JSON.stringify(profileContent)
    );
    if (type === "tip") {
      profileContentToBeUpdated[selectedProfile][reportType][contentType][
        tipSection
      ].tipsArray[index].text[tipsLanguage] = updatedTip;
    } else if (type === "svg") {
      profileContentToBeUpdated[selectedProfile][reportType][contentType][
        tipSection
      ].tipsArray[index].svg = updatedTip;
    } else {
      profileContentToBeUpdated[selectedProfile][reportType][contentType][
        tipSection
      ].tipsArray[index].mediaUrl = updatedTip;
    }
    setProfileContent(profileContentToBeUpdated);
  };

  const updateTipHeader = (value, type) => {
    const profileContentToBeUpdated = JSON.parse(
      JSON.stringify(profileContent)
    );
    profileContentToBeUpdated[selectedProfile][reportType][contentType][
      tipSection
    ][type][tipsLanguage] = value;

    setProfileContent(profileContentToBeUpdated);
  };

  const addTipSection = () => {
    const sampleTipSection = {
      header: {
        ...availableLangObj,
      },
      subHeader: {
        ...availableLangObj,
      },
      tipsArray: [
        {
          text: {
            ...availableLangObj,
          },
          svg: "",
        },
      ],
    };
    const profileContentToBeUpdated = JSON.parse(
      JSON.stringify(profileContent)
    );
    profileContentToBeUpdated[selectedProfile][reportType][contentType].push(
      sampleTipSection
    );
    setProfileContent(profileContentToBeUpdated);
  };

  const updateProfileContent = async () => {
    console.log("updatedContent", profileContent);
    const idToken = localStorage.getItem("idTokenBilling");
    const requestConfig = {
      headers: {
        authorization: idToken,
      },
      method: "POST",
      url: `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/content/profile?version=${version}`,
      validateStatus: function (status) {
        return status >= 200 && status <= 502;
      },
      data: JSON.stringify(profileContent),
    };
    const response = await axios(requestConfig);
    if (response?.data?.isSuccess) {
      alert.success("Updated Successfully");
    }
    return response;
  };

  const handlingRequest = async () => {
    setUpdateLoader(true);
    try {
      const response = await updateProfileContent();
      console.log("response", response);

      if (response.status === 401) {
        await regenerateToken();
        const response = await updateProfileContent();
        console.log("response generated after regeneration", response);
      }
    } catch (e) {
      setUpdateLoader(false);
      console.log(e.message);
      alert.error("Something went wrong. Please try again");
    }
    setUpdateLoader(false);
  };

  const updateOthers = (content, type) => {
    const requiredProfileContent = JSON.parse(JSON.stringify(profileContent));
    requiredProfileContent[selectedProfile][reportType][type] = content;
    setProfileContent(requiredProfileContent);
  };

  const addnewLang = () => {
    const newData = JSON.parse(JSON.stringify(profileContent));
    const addLanguage = (obj, newLangKey, newLangValue) => {
      if (Array.isArray(obj)) {
        obj.forEach((item) => addLanguage(item, newLangKey, newLangValue));
      } else {
        for (let key in obj) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            addLanguage(obj[key], newLangKey, newLangValue);
          }

          if (
            key === "en"
            // obj.hasOwnProperty("hi") &&
            // obj.hasOwnProperty("ar")
          ) {
            if (!obj.hasOwnProperty(newLangKey)) obj[newLangKey] = newLangValue;
          }
        }
      }
    };
    addLanguage(newData, newLangKey, "");
    setAvailableLang([...availableLang, newLangKey]);
    setAvailableLangObj({ ...availableLangObj, [newLangKey]: "" });
    setAvailableLangArray({ ...availableLangArray, [newLangKey]: [] });
    setProfileContent(newData);
    window.alert("Succesfully added new language");
    setNewLangKey("");
  };

  const newLangList = languageOptions.filter(
    (each) => !availableLang.includes(each.value)
  );

  // Function to handle language change
  const handleLanguageChange = (selectedLangCode) => {
    const selectedLangName = availableLanguageNames[selectedLangCode] || selectedLangCode;
    setUserSelectedLanguage(selectedLangCode);
    setUserSelectedLanguageName(selectedLangName);

    setSelectedReportLanguage(selectedLangName)
    setSelectedReportLanguageCode(selectedLangCode)
    
    // Update language and tipsLanguage when user changes selection
    setLanguage(selectedLangCode);
    setTipsLanguage(selectedLangCode);
  };

  const versionName = version ? `(${version})` : "(live)";
  // const storedVersions = JSON.parse(localStorage.getItem("versionData"));
  // const allVersions = storedVersions?.length
  //   ? [...storedVersions.map((each) => each.name), "live"]
  //   : ["live"];
  

    const onFileImport = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }
    
    try {
      const newProfileContent = await handleImport(e);
      setProfileContent(newProfileContent);
      alert.success("Content imported successfully!");
      console.log("Imported content:", newProfileContent);
    } catch (error) {
      console.error(error);
      alert.error(error.message);
    }
    
    e.target.value = null;
  };


  const handleToggleChange = (event) => {
    setShowUI(event.target.checked);
  };

  // 1. Define the Switch component
  const JsonToggle = (
    <FormControlLabel
      control={
        <Switch
          checked={showUI}
          onChange={handleToggleChange}
        />
      }
      label="Show Preview"
    />
  );

  return (
    <>
      {pageLoader ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <LoadingView />
        </Box>
      ) : (
        <>
          <Stack mt={2} direction={"row"} gap={2}>
            <Box
              flexGrow={1}
              sx={{
                // height: "calc(100vh - 315px)",
                // overflowY: "auto",
                padding: "8px",
              }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <LabelElement title={`Update Profile Content ${versionName}`} />
                <div className="ms-2">
                  <Form.Select
                    style={{ textTransform: "none" }}
                    onChange={(e) => {
                      setEditVersion(e.target.value)
                      setVersion(e.target.value)
                    }}
                    value={version}
                  >
                    <option value="">Live (default)</option>
                    {storedVersions.map((each, index) => (
                      <option
                        style={{ textTransform: "none" }}
                        key={index}
                        value={each.name}
                      >
                        {each.name.toLowerCase()}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>

              {/* Add language button - Only show for admin users */}
              {loginData && loginData.role === "admin" && (
                <Stack direction="row" flexWrap="wrap" gap={2} my={2}>
                  <Stack direction={"row"} alignItems={"center"} gap={2}>
                    <h4 style={{ margin: "0" }}>Add New Language</h4>
                    <div className="ms-2">
                      <Form.Select
                        style={{ textTransform: "none" }}
                        value={newLangKey}
                        onChange={(e) => setNewLangKey(e.target.value)}
                      >
                        {newLangList.map((each, index) => (
                          <option
                            style={{ textTransform: "none" }}
                            key={index}
                            value={each.value}
                          >
                            {each.name}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                    <button
                      className="btn btn-info ms-2"
                      onClick={addnewLang}
                      disabled={
                        !(
                          newLangKey &&
                          profileContent &&
                          Object.keys(profileContent)?.length
                        )
                      }
                    >
                      Add
                    </button>
                  </Stack>
                </Stack>
              )}

              {/* Language Selection - Show for all users */}
              <Stack direction="row" flexWrap="wrap" gap={2} my={2}>
                <Stack direction={"row"} alignItems={"center"} gap={2}>
                  <h4 style={{ margin: "0px", whiteSpace: "nowrap" }}>Select Language:</h4>
                  <Form.Select
                    style={{ textTransform: "none", Width: "100px" }}
                    value={userSelectedLanguage}
                    onChange={(e) => handleLanguageChange(e.target.value)}
                  >
                    {availableLang.map((langCode) => (
                      <option
                        key={langCode}
                        value={langCode}
                        style={{ textTransform: "none" }}
                      >
                        {availableLanguageNames[langCode] || langCode}
                      </option>
                    ))}
                  </Form.Select>
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowLanguagePopup(true)}
                    style={{ height: "38px", padding: "6px 12px" }}
                  >
                    Add
                  </button>
                </Stack>
              </Stack>

              {/* Available Languages - Show for all users */}
              <Stack direction="row" flexWrap="wrap" gap={2} my={2}>
                <Stack direction={"row"} alignItems={"center"} gap={1}>
                  <h4 style={{ margin: "0px" }}>Available Languages:</h4>
                  {availableLang.map((each, idx) => (
                    <p key={idx} style={{ margin: "0px" }} className="ms-3">
                      {availableLanguageNames[each]}
                    </p>
                  ))}
                </Stack>
              </Stack>

              {/* Select Profile */}
              <InputGroup>
                <InputGroup.Text>Select Profile</InputGroup.Text>
                {/* <p className="mb-2">Select Profile</p> */}
                <Form.Select
                  className="form-control form-select"
                  id="profile Drop Down"
                  onChange={(e) => {
                    setSelectedProfile(e.target.value);
                    // resetting other states
                    setReportType("dynamic"); // Set to default report type
                    setContentType("");
                    setLanguage(userSelectedLanguage); // Set to user selected language
                    setTipSection("");
                    setTipsLanguage(userSelectedLanguage); // Set to user selected language
                  }}
                >
                  <option hidden>Select Profile</option>
                  {Object.keys(profileContent).map((eachProfile, index) => (
                    <option key={eachProfile} value={eachProfile}>
                      {eachProfile}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>

              {/* Report Type Display - Show for all users */}
              {selectedProfile !== "" ? (
                <InputGroup className="mt-3">
                  <InputGroup.Text>Report Type</InputGroup.Text>
                  <div
                    className="form-control"
                    style={{
                      backgroundColor: "#f8f9fa",
                      color: "#495057",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px"
                    }}
                  >
                    {selectedReportType || "Loading..."}
                  </div>
                </InputGroup>
              ) : (
                ""
              )}
              {/* select type of content to edit */}
              {reportType !== "" && reportType !== "others" && (
                <InputGroup className="mt-3">
                  <InputGroup.Text>Profile Header</InputGroup.Text>
                  {/* <p className="mb-2 mt-2">Profile Header</p> */}
                  <Form.Select
                    className="form-control form-select"
                    id="profile Drop Down"
                    onChange={(e) => {
                      setContentType(e.target.value);
                      // Set language automatically to the user selected language
                      setLanguage(userSelectedLanguage);
                      setTipSection("");
                      setTipsLanguage(userSelectedLanguage);
                    }}
                    value={contentType}
                  >
                    <option hidden>Select Type</option>
                    {Object.keys(
                      profileContent[selectedProfile][reportType]
                    ).map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </Form.Select>
                </InputGroup>
              )}

              {/* Selected Language Display - Show automatically when Profile Header is selected */}
              {contentType !== "" && contentType === "about" && (
                <InputGroup className="mt-3">
                  <InputGroup.Text>Selected Language</InputGroup.Text>
                  <div
                    className="form-control"
                    style={{
                      backgroundColor: "#f8f9fa",
                      color: "#495057",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px"
                    }}
                  >
                    {userSelectedLanguageName || "Loading..."}
                  </div>
                </InputGroup>
              )}

              {contentType !== "" && contentType === "about" && (
                <>
                  <InputGroup className="mt-3">
                    <InputGroup.Text>Profile Heading</InputGroup.Text>
                    {/* <p className="w-100 mb-2 mt-2">Profile Heading </p> */}
                    <Form.Control
                      value={
                        profileContent[selectedProfile][reportType][
                          contentType
                        ]["header"][language]
                      }
                      onChange={(e) =>
                        setProfileContent((prevState) => {
                          return {
                            ...prevState,
                            [selectedProfile]: {
                              ...prevState[selectedProfile],
                              [reportType]: {
                                ...prevState[selectedProfile][reportType],
                                [contentType]: {
                                  ...prevState[selectedProfile][reportType][
                                    contentType
                                  ],
                                  header: {
                                    ...prevState[selectedProfile][reportType][
                                      contentType
                                    ].header,
                                    [language]: e.target.value,
                                  },
                                },
                              },
                            },
                          };
                        })
                      }
                    />
                  </InputGroup>
                  {/* Profile Content */}
                  <InputGroup className="mt-3">
                    <InputGroup.Text>Profile Content</InputGroup.Text>
                    {/* <p className="mb-2 mt-2">Profile Content</p> */}
                    <Form.Control
                      as="textarea"
                      // className="w-100 form-control"
                      rows="7"
                      value={
                        profileContent[selectedProfile][reportType][
                          contentType
                        ]["text"][language]
                      }
                      onChange={(e) => {
                        setProfileContent((prevState) => {
                          return {
                            ...prevState,
                            [selectedProfile]: {
                              ...prevState[selectedProfile],
                              [reportType]: {
                                ...prevState[selectedProfile][reportType],
                                [contentType]: {
                                  ...prevState[selectedProfile][reportType][
                                    contentType
                                  ],
                                  text: {
                                    ...prevState[selectedProfile][reportType][
                                      contentType
                                    ].text,
                                    [language]: e.target.value,
                                  },
                                },
                              },
                            },
                          };
                        });
                      }}
                    ></Form.Control>
                  </InputGroup>

                  {/* Media Url in about section for Vizapp only.*/}
                  {reportType === "vizapp" && (
                    <InputGroup className="mt-3">
                      <InputGroup.Text>Media URL</InputGroup.Text>
                      {/* <p className="mb-2 mt-2">Media URL</p> */}
                      <Form.Control
                        onChange={(e) => {
                          setProfileContent((prevState) => {
                            return {
                              ...prevState,
                              [selectedProfile]: {
                                ...prevState[selectedProfile],
                                [reportType]: {
                                  ...prevState[selectedProfile][reportType],
                                  [contentType]: {
                                    ...prevState[selectedProfile][reportType][
                                      contentType
                                    ],
                                    mediaUrl: e.target.value,
                                  },
                                },
                              },
                            };
                          });
                        }}
                        value={
                          profileContent[selectedProfile][reportType][
                            contentType
                          ]["mediaUrl"]
                        }
                        placeholder="Enter Media Url"
                      />
                    </InputGroup>
                  )}
                </>
              )}
              {contentType !== "" && contentType === "tips" && (
                <>
                  <div className="d-flex flex-row justify-content-start align-items-center mb-2 mt-2">
                    <p className="mb-0 mt-0">Profile Tips </p>
                    <button
                      className="btn btn-success mx-2"
                      onClick={() => {
                        addTipSection();
                        setTipSection(
                          profileContent[selectedProfile][reportType][
                            contentType
                          ].length
                        );
                      }}
                    >
                      Add Tip Section
                    </button>
                  </div>
                  <select
                    className="form-control form-select"
                    id="profile tips main level Drop Down"
                    onChange={(e) => {
                      setTipSection(e.target.value);
                      // Set tips language automatically to the user selected language
                      setTipsLanguage(userSelectedLanguage);
                    }}
                    value={tipSection}
                  >
                    <option hidden>Select Tip Section</option>
                    {profileContent[selectedProfile][reportType][
                      contentType
                    ].map((eachTipSection, idx) => {
                      // Get the tip header name for the user selected language or fallback to English
                      const displayLanguage = tipsLanguage || userSelectedLanguage || "en";
                      const tipHeaderName = eachTipSection.header?.[displayLanguage] || 
                                          eachTipSection.header?.en || 
                                          eachTipSection.header?.hi || 
                                          eachTipSection.header?.ar || 
                                          `Tip Section-${idx + 1}`;
                      
                      return (
                        <option
                          key={`tipsection-${idx}`}
                          value={idx}
                        >{tipHeaderName}</option>
                      );
                    })}
                    {/* <option value={'add tip section'}>Add Tip Section</option> */}
                  </select>
                </>
              )}

              {tipSection !== "" && (
                <InputGroup className="mt-3">
                  <InputGroup.Text>Tips Language</InputGroup.Text>
                  <div
                    className="form-control"
                    style={{
                      backgroundColor: "#f8f9fa",
                      color: "#495057",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px"
                    }}
                  >
                    {userSelectedLanguageName || "Loading..."}
                  </div>
                </InputGroup>
              )}

              {tipSection !== "" && (
                <>
                  {/* <p className='w-100 mb-2 mt-2'>Tips and SVG </p> */}
                  <InputGroup className="mt-3">
                    <InputGroup.Text>Tip Header</InputGroup.Text>
                    {/* <p className="w-100 mb-2 mt-2">Tip Header </p> */}
                    <Form.Control
                      value={
                        profileContent[selectedProfile][reportType][
                          contentType
                        ][tipSection]["header"][tipsLanguage]
                      }
                      onChange={(e) =>
                        updateTipHeader(e.target.value, "header")
                      }
                    />
                  </InputGroup>
                  {Object.keys(
                    profileContent[selectedProfile][reportType][contentType][
                      tipSection
                    ]
                  ).includes("subHeader") && (
                    <>
                      <p className="w-100 mb-2 mt-2">Tip Sub Header </p>
                      <Form.Control
                        value={
                          profileContent[selectedProfile][reportType][
                            contentType
                          ][tipSection]["subHeader"][tipsLanguage]
                        }
                        onChange={(e) =>
                          updateTipHeader(e.target.value, "subHeader")
                        }
                      />
                    </>
                  )}

                  {profileContent[selectedProfile][reportType][contentType][
                    tipSection
                  ]["tipsArray"].map((eachTip, index) => (
                    <div key={`tip-index${index}`} className="mb-2">
                      {index === 0 && (
                        <div className="d-flex mt-2 mb-2">
                          <div className="w-100 d-flex flex-grow">
                            <p className="mb-2 mt-0">Tip</p>
                            <button
                              className="btn btn-success"
                              style={{
                                height: "30px",
                                width: "85px",
                                marginLeft: "15px",
                              }}
                              onClick={() => {
                                addTips();
                              }}
                            >
                              ADD TIP
                            </button>
                          </div>
                          {/* <div className='w-100' style={{ marginRight: '85px' }}>
                          {index === 0 && <p className='mb-2 mt-0'>Tip Svg</p>}
                        </div> */}
                        </div>
                      )}
                      <div
                        className="w-100 d-flex"
                        style={{ marginRight: "15px" }}
                      >
                        <div className="d-flex flex-column w-100">
                          {index === 0 && (
                            <label className="mb-2">Content</label>
                          )}
                          <textarea
                            className="w-100 form-control"
                            value={
                              profileContent[selectedProfile][reportType][
                                contentType
                              ][tipSection]["tipsArray"][index]["text"][
                                tipsLanguage
                              ]
                            }
                            placeholder="Update the Tip Content"
                            onChange={(e) => {
                              updateTip(e.target.value, "tip", index);
                            }}
                          />
                        </div>
                        <div className="d-flex flex-column w-100 mx-3">
                          {index === 0 && <label className="mb-2">SVG</label>}
                          <Form.Control
                            className="w-100 form-control "
                            placeholder="Enter SVG name"
                            value={
                              profileContent[selectedProfile][reportType][
                                contentType
                              ][tipSection]["tipsArray"][index].svg
                            }
                            onChange={(e) => {
                              updateTip(e.target.value, "svg", index);
                            }}
                          />
                        </div>

                        {reportType === "vizapp" && (
                          <div className="d-flex flex-column w-100">
                            {index === 0 && (
                              <label className="mb-2">Media Url</label>
                            )}
                            <Form.Control
                              className="w-100 form-control"
                              placeholder="Enter Media URL"
                              value={
                                profileContent[selectedProfile][reportType][
                                  contentType
                                ][tipSection]["tipsArray"][index].mediaUrl
                              }
                              onChange={(e) => {
                                updateTip(e.target.value, "mediaUrl", index);
                              }}
                            />
                          </div>
                        )}

                        <button
                          className={`btn btn-danger ${
                            index === 0 ? "mt-4" : ""
                          }`}
                          style={{
                            height: "30px",
                            width: "75px",
                            marginLeft: "15px",
                          }}
                          onClick={() => {
                            removeTips(eachTip);
                          }}
                        >
                          Remove
                        </button>
                      </div>
                      <div className=" d-flex flex-column"></div>
                    </div>
                  ))}
                </>
              )}

              {/* Adding Others field */}
              {reportType === "others" && (
                <>
                  <label className="mt-2">Href</label>
                  <Form.Control
                    value={
                      profileContent[selectedProfile][reportType]["href"]
                        ? profileContent[selectedProfile][reportType]["href"]
                        : ""
                    }
                    placeholder="href"
                    onChange={(e) => {
                      updateOthers(e.target.value, "href");
                    }}
                  />
                  <label className="mt-2">Recommendations</label>
                  <Form.Control
                    onChange={(e) => {
                      updateOthers(e.target.value, "recommendation");
                    }}
                    value={
                      profileContent[selectedProfile][reportType][
                        "recommendation"
                      ]
                        ? profileContent[selectedProfile][reportType][
                            "recommendation"
                          ]
                        : ""
                    }
                    placeholder="Recommendations"
                  />
                  <label className="mt-2">Concern Areas</label>
                  <Form.Control
                    onChange={(e) => {
                      updateOthers(e.target.value, "concernArea");
                    }}
                    value={
                      profileContent[selectedProfile][reportType]["concernArea"]
                        ? profileContent[selectedProfile][reportType][
                            "concernArea"
                          ]
                        : ""
                    }
                    placeholder="Concern areas"
                  />
                </>
              )}
            </Box>


<div>
         {selectedProfile && JsonToggle}
         <label 
            htmlFor="profile-import-upload" 
            className="btn btn-primary mt-2 mx-2"
             style={{ width: "140px", borderRadius: "12px" }}
          >
            Import Content
          </label>
          <input 
            id="profile-import-upload"
            type="file" 
            accept=".xlsx, .xls, .csv"
            onChange={onFileImport} 
            style={{ display: 'none' }} 
          />

          <button
            className="btn btn-primary mt-2 mx-2"
            style={{ width: "140px", borderRadius: "12px" }}
            onClick={() => handleExport(profileContent)}
          >
            Export Content
          </button>

            {selectedProfile && (
              <div className="mt-3">
                {
                  showUI ? <ProfileDisplay profileData={profileContent[selectedProfile]} selectedReportType={selectedReportType} selectedReportLanguageCode={selectedReportLanguageCode}/> :
                  <ProfileEditorManager 
                    profileContent={profileContent}
                    setProfileContent={setProfileContent}
                    selectedProfile={selectedProfile}
                    setSelectedProfile={setSelectedProfile}
                  />
                }
              </div>
            )}
          </div>
          </Stack>

          {/* Buttons */}
          <div>
          <button
            onClick={() => handlingRequest()}
            disabled={updateLoader}
            className="btn btn-primary mt-2 mx-2"
            style={{ width: "140px", borderRadius: "12px" }}
          >
            {updateLoader ? (
              <Spinner
                animation="border"
                role="status"
                size="sm"
                style={{ color: "#fff" }}
              ></Spinner>
            ) : (
              "Confirm Changes"
            )}
          </button>
        </div>
        </>
      )}

      {/* Language Add Popup Modal */}
      {showLanguagePopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={() => setShowLanguagePopup(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "40px",
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
              maxWidth: "500px",
              width: "90%",
              textAlign: "center",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowLanguagePopup(false)}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#999",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                transition: "all 0.2s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#f5f5f5";
                e.target.style.color = "#666";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#999";
              }}
              title="Close"
            >
              ×
            </button>

            {/* Header with Icon */}
            <div style={{ marginBottom: "25px" }}>
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#e3f2fd",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 15px",
                  fontSize: "24px",
                }}
              >
                🌐
              </div>
              <h4 style={{ margin: "0", color: "#333", fontSize: "24px", fontWeight: "600" }}>
                Add New Language
              </h4>
            </div>

            {/* Content */}
            <div style={{ marginBottom: "30px" }}>
              <p style={{ 
                marginBottom: "20px", 
                color: "#666", 
                fontSize: "16px",
                lineHeight: "1.5"
              }}>
                To add a new language to the system, please contact our support team. 
                They will help you with the language integration process.
              </p>
              
              {/* Support Contact Information */}
              <div style={{
                backgroundColor: "#f8f9fa",
                padding: "20px",
                borderRadius: "8px",
                border: "1px solid #e9ecef",
                marginBottom: "20px"
              }}>
                <h5 style={{ 
                  margin: "0 0 15px 0", 
                  color: "#495057", 
                  fontSize: "16px",
                  fontWeight: "600"
                }}>
                  Contact Support Team
                </h5>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  {SUPPORT_EMAILS.map((email, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                      <span style={{ color: "#6c757d", fontSize: "14px" }}>📧</span>
                      <a
                        href={`mailto:${email}?subject=Request to Add New Language&body=Hello Support Team,%0D%0A%0D%0AI would like to request adding a new language to the system.%0D%0A%0D%0APlease let me know the process and requirements.%0D%0A%0D%0AThank you!`}
                        style={{
                          color: "#007bff",
                          textDecoration: "none",
                          fontSize: "15px",
                          fontWeight: "500",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          transition: "all 0.2s ease"
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#e3f2fd";
                          e.target.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.textDecoration = "none";
                        }}
                      >
                        {email}
                      </a>
                    </div>
                  ))}
                </div>
              </div>

              <p style={{ 
                margin: "0", 
                color: "#6c757d", 
                fontSize: "14px",
                fontStyle: "italic"
              }}>
                Click on email address above to open your email client with a pre-filled message.
              </p>
            </div>

            {/* Action Buttons */}
            <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowLanguagePopup(false)}
                style={{ 
                  padding: "10px 24px",
                  borderRadius: "6px",
                  border: "1px solid #6c757d",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#6c757d";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6c757d";
                }}
              >
                Close
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  window.open(`mailto:${SUPPORT_EMAIL}?subject=Request to Add New Language&body=Hello Support Team,%0D%0A%0D%0AI would like to request adding a new language to the system.%0D%0A%0D%0APlease let me know the process and requirements.%0D%0A%0D%0AThank you!`);
                }}
                style={{ 
                  padding: "10px 24px",
                  borderRadius: "6px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#0056b3";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#007bff";
                }}
              >
                Contact Support
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ProfileContent;
